import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.demography'),
    id: 'demography',
    sidebar: [
        {
            id: 'countries',
            label: i18n.tc('configuration.sections.countries', 2),
            icon: 'fal fa-globe-stand',
            routeName: 'DemographyCountries',
            hasChildren: false
        },
        {
            id: 'provinces',
            label: i18n.tc('configuration.sections.provinces', 2),
            icon: 'fal fa-map-marked',
            routeName: 'DemographyProvinces',
            hasChildren: false
        },
        {
            id: 'municipalities',
            label: i18n.tc('configuration.sections.municipalities', 2),
            icon: 'fal fa-map-marker-check',
            routeName: 'DemographyMunicipalities',
            hasChildren: false
        },
        {
            id: 'gender',
            label: i18n.t('configuration.sections.gender'),
            icon: 'fal fa-venus-mars',
            routeName: 'DemographyGender',
            hasChildren: false
        }
    ]
}
